module.exports = __webpack_public_path__ + "img/icon-master-card.2c48c58f.svg";